import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import KSAVRF from '../assets/images/KSA-VRF.png';
import KSAGRF from '../assets/images/KSA-GRF.png';//KSA-GRF.png
import KSAGEOID21 from '../assets/images/KSA-GEOID21.png';//KSA-GEOID21.png
import arrowGreen from '../assets/icons/arrow-green.svg'
//


function SANSRS() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('sansrs_title')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <h3 style={{ color: 'black' }}>{t('sansrs_def1')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub1')}</p>
          <p style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub2')}</p>
          <p style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub3')}</p>
          <p style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub4')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub4_p1')}</li>
          <li style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub4_p2')}</li>
          <li style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub4_p3')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub5')} 
          
            <a href={t('SANSRS_Implementation_Guide_URL')} download> 
                  {t('sansrs_def1_sub5_link')}
                </a>
                </p>
          <p style={{ textAlign: 'justify' }}>{t('sansrs_def1_sub6')} 
          <a href={t('SANSRS_Technical_Summary_URL')} download> 
                  {t('sansrs_def1_sub6_link')}
                </a>
            </p>
            <p style={{ textAlign: 'justify' }}><b>{t('sansrs_TEMPORAL_SANSRS')} </b>
          <a href={t('sansrs_TEMPORAL_SANSRS_URL')} download> 
                  {t('sansrs_TEMPORAL_SANSRS_link')}
                </a>
            </p>
            
          <br />          
        </div>
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    <section class="services"style={{gap:"6rem", padding:"5rem"}}>
      <div class="service-card">
      <Link className="nav-link" to="/Geodesy/Sansrs/KSAVRF14">
      <div class="image-container">
          <img src={KSAVRF} alt="Geographical Names" />
          <div class="icon-overlay">
            <img src={arrowGreen} alt="Arrow Icon" />
          </div>
          <div class="floating-text">
            <h3>{t('KSA_VRF')}</h3>
          </div>
        </div>                  </Link>
        
        
      </div>
      <div class="service-card">
      <Link className="nav-link" to="/Geodesy/Sansrs/KSAGRF17">
        <div class="image-container">
          <img
            src={KSAGRF}
            alt="Open Geospatial Data For SDGs"
          />
          <div class="icon-overlay">
            <img src={arrowGreen} alt="Arrow Icon" />
          </div>
          <div class="floating-text">
            <h3 data-key="open_geospatial_data_for_sdgs">
            {t('KSA_GRF')}
            </h3>
          </div>
        </div></Link>
       
      </div>
      <div class="service-card">
      <Link className="nav-link" to="/Geodesy/Sansrs/KSAGEOID17">
        <div class="image-container">
          <img
            src={KSAGEOID21}
            alt="National Tide Gauge Network"
          />
          <div class="icon-overlay">
            <img src={arrowGreen} alt="Arrow Icon" />
          </div>
          <div class="floating-text">
            <h3 data-key="geodesy-sub">
            {t('KSA_Geoid')}
            </h3>
          </div>
        </div></Link>
       
      </div>

      
    </section>
    </div>
);
}

export default SANSRS;
